import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LearningCenterManagementService } from './learning-center-management.service';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
@Component({
  selector: 'app-learning-center-management',
  templateUrl: './learning-center-management.component.html',
  styleUrls: ['./learning-center-management.component.scss']
})
export class LearningCenterManagementComponent implements OnInit {
  searchTerm: string;
  isLoading
  listOfData = new BehaviorSubject<any[]>([]);
  originalData
  listOfColumn = [
    {
      title: 'ชื่อศูนย์เรียนรู้ย่อย	',
    },
    {
      title: 'วันที่/เวลาที่สร้าง',
      compare: (a, b) => moment(a.CREATE_DATE).diff(moment(b.CREATE_DATE)),
      orderBy: 'descend',
      direction: ['ascend', 'descend']
    },
    {
      title: 'ผู้สร้าง',
    },
    {
      title: 'สถานะการเผยแพร่',
    },
    {
      title: 'เรียกดู',
    },
  ]

  constructor(
    private router: Router,
    private learningCenterManagementService: LearningCenterManagementService,
    private gobalFunctionService: GobalFunctionService,
  ) { }

  ngOnInit(): void {
    this.gobalFunctionService.setTitle('การจัดการศูนย์การเรียนรู้');
    this.isLoading = true;
    this.learningCenterManagementService.getAllLearningCenter().subscribe((res) => {
      this.originalData = res.result; // store original data
      this.listOfData.next(res.result);
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
      alert('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
      window.location.reload();
  });
  }

  handleOpenLearningCenterEditor(CENTER_ID) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/learning-center-management/manage-learning-center'], { queryParams: { CENTER_ID } })
    );

    window.open(url, '_blank');
  }

  handleOpenLearningCenterManage() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/learning-center-management/manage-learning-center'])
    );

    window.open(url, '_blank');
  }

  search() {
    if (this.searchTerm) {
      const filteredData = this.originalData.filter(item => item.CENTER_NAME.includes(this.searchTerm));
      this.listOfData.next(filteredData);
    } else {
      this.listOfData.next(this.originalData); // restore original data when search term is cleared
    }
  }

  changeStatus(id, viewStatus) {
    const status = viewStatus === 1 ? 0 : 1;
    this.isLoading = true;
    this.learningCenterManagementService.updateViewStatus({ CENTER_ID: id, VIEW_STATUS: status }).subscribe((res) => {
      if (res.success) {
        this.learningCenterManagementService.getAllLearningCenter().subscribe((res) => {
          this.originalData = res.result; // store original data
          this.listOfData.next(res.result);
          this.isLoading = false;
        });
      }
    }, (error) => {
      console.log(error);
      this.isLoading = false;
      alert('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
    }
    );
  }


}
